document.addEventListener('DOMContentLoaded', function () {
  function initGalleryArrows() {
    const gallery = document.querySelector('product-gallery-modal');
    if (!gallery || gallery.dataset.arrowsInit) return;

    const swiperEl = gallery.querySelector('.swiper');
    if (!swiperEl || !swiperEl.swiper) return;

    gallery.dataset.arrowsInit = 'true';
    const swiper = swiperEl.swiper;

    // Use the parent of the swiper so overflow:hidden doesn't clip the arrows
    const container = swiperEl.parentElement;
    container.style.position = 'relative';

    const prevBtn = document.createElement('button');
    const nextBtn = document.createElement('button');

    const base = `
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9999;
      background: rgba(255,255,255,0.75);
      border: none;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
    `;

    const prevSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>`;
    const nextSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;

    prevBtn.setAttribute('style', base + 'left: 12px;');
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = prevSVG;

    nextBtn.setAttribute('style', base + 'right: 12px;');
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = nextSVG;

    prevBtn.addEventListener('click', () => swiper.slidePrev());
    nextBtn.addEventListener('click', () => swiper.slideNext());

    container.appendChild(prevBtn);
    container.appendChild(nextBtn);
  }

  let attempts = 0;
  const interval = setInterval(() => {
    initGalleryArrows();
    attempts++;
    if (attempts > 20) clearInterval(interval);
  }, 300);
});
